export default "__VITE_ASSET__COFfLlt3__"